var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconLocation = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 25,
    viewBox: "0 0 19 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.38281 0C4.53652 0 0.59375 3.94277 0.59375 8.78906C0.59375 10.4265 1.04731 12.0244 1.90571 13.4107L8.88252 24.6538C9.01616 24.8691 9.25161 25 9.50483 25C9.50679 25 9.50869 25 9.51064 25C9.76606 24.998 10.002 24.8631 10.1332 24.6439L16.9322 13.292C17.7432 11.935 18.1719 10.3779 18.1719 8.78906C18.1719 3.94277 14.2291 0 9.38281 0ZM15.6751 12.5399L9.49375 22.8606L3.15073 12.639C2.43623 11.4851 2.04883 10.1538 2.04883 8.78906C2.04883 4.75049 5.34424 1.45508 9.38281 1.45508C13.4214 1.45508 16.7119 4.75049 16.7119 8.78906C16.7119 10.1133 16.35 11.4105 15.6751 12.5399Z",
    fill: "#FA114F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38281 4.39453C6.95967 4.39453 4.98828 6.36592 4.98828 8.78906C4.98828 11.1967 6.92759 13.1836 9.38281 13.1836C11.8683 13.1836 13.7773 11.1703 13.7773 8.78906C13.7773 6.36592 11.806 4.39453 9.38281 4.39453ZM9.38281 11.7285C7.75894 11.7285 6.44336 10.4085 6.44336 8.78906C6.44336 7.17363 7.76738 5.84961 9.38281 5.84961C10.9982 5.84961 12.3174 7.17363 12.3174 8.78906C12.3174 10.3849 11.0324 11.7285 9.38281 11.7285Z",
    fill: "#FA114F"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconLocation, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Icon_Location.2be455ed.svg";
export { ForwardRef as ReactComponent };